export default "__VITE_ASSET__yI8YKWZ6__"